import React from "react";
import { Divider } from "primereact/divider";

const QuotePreview = ({ quotePreviewData, type = "preview", closeApproval }) => {
    if (!quotePreviewData) return null;
    let data = quotePreviewData.body;
    let errors = quotePreviewData.invalid_sku;
    const getSKUError = (sku) => {
        // if (!sku) return "SKU missing";
        // if (errors && errors.length) {
        //     const invalidSKU = errors.find((item) => item.sku === sku);
        //     if (invalidSKU) {
        //         return invalidSKU.message;
        //     }
        // }
        return undefined;
    };

    const getStatus = (status) => {
        switch (status) {
            case "Accepted":
                return "Approved";
            case "Rejected":
                return "Not Approved";
            case "PartiallyAccepted":
                return "Partially Accepted";
            default:
                return "Pending";
        }
    };
    const formatCurrency = (value) => {
        if (value == null || value === "") return "";

        const num = Number(value);

        // If negative → return "-$326.48"
        if (num < 0) {
            return `-$${Math.abs(num).toFixed(2)}`;
        }

        // If positive → return "$326.48"
        return `$${num.toFixed(2)}`;
    };
    return (
        <div className="p-3 font-Gerstner-ProgramRegular">
            <div className="flex align-items-center justify-content-between" style={{ gap: 10, fontFamily: "Larken" }}>
                <h2 className="m-0 font-light">Quote{type === "preview" ? " Preview" : ""}</h2>
                {type === "approval" && (
                    <button
                        onClick={(e) => {
                            e.target.blur();
                            closeApproval();
                        }}
                        style={{
                            background: "transparent",
                            border: "none",
                            fontSize: "20px",
                            cursor: "pointer",
                        }}
                    >
                        ✕
                    </button>
                )}
            </div>
            <div className="flex flex-wrap mt-3" style={{ gap: 15 }}>
                <div className="flex-grow-1">
                    <p className="text-xl mb-2 font-larken">Quote ID</p>
                    <p className="m-0 text-lg font-Gerstner-ProgramRegular">{data.quoteId ?? "--"}</p>
                </div>
                <div className="flex-grow-1">
                    <p className="text-xl mb-2 font-larken">Project</p>
                    <p className="m-0 text-lg">{data.project ?? "--"}</p>
                </div>
                <div className="flex-grow-1">
                    <p className="text-xl mb-2 font-larken">Issue Date</p>
                    <p className="m-0 text-lg">{data.issueDate ?? "--"}</p>
                </div>
                <div className="flex-grow-1">
                    <p className="text-xl mb-2 font-larken">Issue By</p>
                    <p className="m-0 text-lg">{data.issueBy ?? "--"}</p>
                </div>
                <div className="flex-grow-1">
                    <p className="text-xl mb-2 font-larken">Status</p>
                    <p className="m-0 text-lg" style={{ color: getStatus(data.status) === "Approved" ? "#9AAB89" : "#BFAD5B" }}>
                        {getStatus(data.status)}
                    </p>
                </div>
            </div>

            {/* Line Items */}
            <div className="designer-card-border p-4 mt-5">
                {data.lineItems.map((item, idx) => (
                    <div key={idx}>
                        <div className="flex justify-content-between mb-2">
                            {/* left section */}
                            <div className="flex align-items-center">
                                {item.imageUrl && (
                                    <div
                                        className="border-round mr-3 flex flex-column align-items-center"
                                        style={{
                                            backgroundColor: "#E5E1CF",
                                            borderRadius: "16px",
                                            padding: "6px",
                                            width: "80px",
                                            height: "80px",
                                        }}
                                    >
                                        <img
                                            src={item.imageUrl || "/images/sofa1.png"}
                                            alt={item.itemName}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                )}
                                <div>
                                    <p className="m-0 text-lg">{item.itemName}</p>
                                    <p className="m-0 mt-2 text-sm">
                                        SKU: <span>{item.sku ? item.sku : "--"}</span>
                                        {/* <span className="font-italic ml-1" style={{ color: "#BFAD5B" }}>
                                            {type === "approval" ? item.sku ?? "--" : getSKUError(item.sku)}
                                            {type === "preview" && getSKUError(item.sku) && <i className="pi pi-exclamation-triangle ml-1" style={{ color: "#BFAD5B" }}></i>}
                                        </span> */}
                                    </p>
                                    <p className="m-0 mt-2 text-sm">Quantity: {item.quantity}</p>
                                    <p className="m-0 mt-2 text-sm">Price: {item.unitPrice ? formatCurrency(item.unitPrice) : "Not Found"}</p>
                                    {item.unitTax && <p className="m-0 mt-2 text-sm">Tax: {formatCurrency(item.unitTax)}</p>}
                                </div>
                            </div>

                            {/* right section */}
                            <div className="flex flex-column items-end">
                                <p className="text-lg m-0" style={{ color: !item.totalPrice ? "#BFAD5B" : "" }}>
                                    {item.totalPrice ? formatCurrency(item.totalPrice) : "Not Found"}
                                </p>
                                {/* approval status below total price */}
                                {type === "approval" && (
                                    <p className="m-0 mt-2 text-lg " style={{ color: getStatus(item.status) === "Approved" ? "#9AAB89" : "#BFAD5B" }}>
                                        {getStatus(item.status)}
                                    </p>
                                )}
                            </div>
                        </div>

                        <Divider style={{ backgroundColor: "#BFAD5B", height: "0.5px" }} />
                    </div>
                ))}

                <div className="flex justify-content-between mt-2 font-bold">
                    <span>Sub Total:</span>
                    <span>{formatCurrency(data.subTotal)}</span>
                </div>
                {data.tax != null && (
                    <div className="flex justify-content-between mt-2 font-bold">
                        <span>Tax:</span>
                        <span>{formatCurrency(data.tax)}</span>
                    </div>
                )}
                {data.discount && (
                    <div className="flex justify-content-between mt-2 font-bold">
                        <span>Discount:</span>
                        <span>{formatCurrency(data.discount)}</span>
                    </div>
                )}
                <div className="flex justify-content-between mt-3 text-xl font-bold">
                    <span>Total:</span>
                    <span>{formatCurrency(data.totalAmount)}</span>
                </div>
            </div>
        </div>
    );
};

export default QuotePreview;
